import { Divider } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import {
  LoaderPinwheel,
  Globe,
  CircleCheck,
  ChevronDown,
  ChevronUp,
} from 'lucide-react'
import type { IMessage } from '@/types/chat'

import Newspaper from '@/assets/images/icon/newspaper.svg?react'
import ArrowUpRightfrom from '@/assets/images/icon/arrow-up-right-circle.svg?react'
import { SseResponseEventEnum } from '@/constants/agent'

interface ICurrent {
  event: string
  data: any
}

const ToolContent = ({ content }: any) => {
  const [showContent, setShowContent] = useState(false)
  const [current, setcurrent] = useState<ICurrent | null>(null)
  const [response, setResponse] = useState<any>({})
  const [curOpenIndex, setCurOpenIndex] = useState<number>(0)

  const { event } = content
  useEffect(() => {
    setcurrent(current)
    if (content?.event === 'toolResponse') {
      // const response = JSON.parse(current?.data.tool?.response || {})
      const response = parseJson(content?.toolObj?.response || {})
      setResponse(response)
      curOpenIndex + 1 !== response.result.length &&
        setTimeout(() => {
          setCurOpenIndex(curOpenIndex + 1)
        }, 400)
    }
  }, [curOpenIndex, content])
  const parseJson = (data: any) => {
    try {
      return JSON.parse(data)
    } catch (error) {
      return {}
    }
  }
  const handleContent = () => {
    setShowContent(!showContent)
  }

  const openWebsite = (url: any) => {
    window.open(url)
  }
  // if (!events?.length) return null

  // 临时方案，只处理搜索工具渲染
  // if (current?.data?.tool?.toolName !== '百度搜索') {
  //   return null
  // }

  return (
    <Warper>
      <div
        className="flex items-center h-[24px] gap-[2px] mb-2 cursor-pointer line-clamp-1"
        onClick={handleContent}
      >
        {event === 'toolResponse' ? (
          <CircleCheck size={16} />
        ) : (
          <LoaderPinwheel size={16} className="animate-spin" />
        )}

        <div className="headline hover:bg-gray-100 pl-1 flex items-center rounded-sm flex-1">
          {(event === 'toolCall' || event === 'toolParams') && (
            <span> 联网搜索：</span>
          )}
          {/* {response?.result && event === 'toolResponse' && (
            <span className="line-clamp-1 flex-1">
              打开网页：{response?.result?.[curOpenIndex]?.title}
            </span>
          )} */}
          {response?.result && event === 'toolResponse' && (
            <span className="line-clamp-1 flex-1">
              搜索完成，共找到
              {response?.result?.length || 0}
              个网页并参考内容
            </span>
          )}
          {showContent ? (
            <ChevronUp strokeWidth={1.5} size={22} />
          ) : (
            <ChevronDown strokeWidth={1.5} size={22} />
          )}
        </div>
      </div>
      {showContent && (
        <div className="content">
          {content?.toolObj?.params &&
            JSON.parse(content?.toolObj?.params) &&
            event === SseResponseEventEnum.toolParams && (
              <>
                <div className="step1 flex items-center gap-1">
                  <Globe className="w-4 h-4" />
                  <div className="headline">
                    联网搜索：
                    {JSON.parse(content?.toolObj?.params)?.keywords}
                  </div>
                </div>
              </>
            )}
          {response?.result ? (
            <div className="step2">
              <div className="cardlist my-2">
                {response?.result.map((item: any, index: number) => {
                  return (
                    <>
                      <div
                        key={index}
                        className="item cursor-pointer"
                        onClick={() => {
                          openWebsite(item.link || item.url)
                        }}
                      >
                        <div className="flex items-center justify-between h-[42px] px-[16px]">
                          <div className="flex-1 truncate text-sm">
                            {index + 1}. {item.title}
                          </div>
                          <ArrowUpRightfrom className="w-[30px]" />
                        </div>
                        <Divider className="my-0" />
                        <div className="px-3 h-8 leading-8 text-sm bg-[#f5f6f8] font-normal text-slate-400 flex items-center">
                          {item.logo && (
                            <img src={item.logo} className="w-4 h-4 mr-1" />
                          )}
                          <span className="w-full truncate">{item.link}</span>
                        </div>
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
          ) : null}

          {content?.toolObj?.response && event === 'toolResponse' && (
            <div className="step3 flex items-center gap-1">
              <Newspaper />
              <div className="headline"> 读取网页并总结内容</div>
            </div>
          )}
        </div>
      )}
    </Warper>
  )
}

const Warper = styled.div`
  .headline {
    color: #1f1f1f;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-bottom: 20px;
    padding: 12px;
    background: rgba(228, 235, 244, 0.6);
    border-radius: 6px;
    .cardlist {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      .item {
        width: calc((100% - 20px) / 2);
        overflow: hidden;
        font-weight: 500;
        line-height: 1.4;
        text-align: left;
        background: #fff;
        border: 1px solid transparent;
        border-radius: 6px;
        &:hover {
          border: 1px solid #004ff8;
        }
      }
    }
  }
  .summarize {
    padding: 12px;
  }
`

export default ToolContent
